import { useQuery } from 'react-query';

import { getSegmentsList as queryFn } from 'api/endPoints/getSegmentsList';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetSegmentsList = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getSegmentsList', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId) && Boolean(params.contractId),
    });
};

export interface QueryParams {
    contractId: number | undefined;
    metaDataId: number | undefined;
}

export interface Segment {
    contractId: number;
    entireProject: boolean;
    filter: {
        filters: {
            name: string;
            data: string[];
            operation: string;
        }[];
    };
    name: string;
    segmentId: number;
    taskCount: number;
    url: string;
}

type QueryFnResponse = Segment[];

type QueryResponse = QueryFnResponse & {};
